export default function MenuAnchors() {
    return {
        init() {
            let menuDrawer = document.querySelector('.menu_drawer');
            let navLinks = document.querySelectorAll('.nav_links .menu-item');
            navLinks.forEach((link) => {
                link.addEventListener('click' , () => {
                    menuDrawer.classList.add('-translate-x-full')
                    menuDrawer.classList.remove('translate-x-0')
                })
            });
        }
    }
}